import React, { useEffect } from 'react';
import { makeStyles } from 'tss-react/mui';

import useStores from 'app/main/hooks/use-stores';
import { FooterBar } from 'main/components/bar/FooterBar';

import Assessment from './Assessment';
import Blog from './Blog';
import { MENU } from './constants';
import Customers from './Customers';
import Feed from './Feed';
import ParterCTA from './ParterCTA';
import Plugins from './Plugins';
import SDK from './SDK';
import Search from './Search';
import Tools from './Tools';

import ScrollUpButton from '../../../layout/components/ScrollUpButton';
import Header from '../components/Header';

const useStyles = makeStyles()({
    mailLayout: {
        background: '#fff'
    },
    footerRoot: {
        '& .MuiTypography-root': {
            fontSize: 16
        },
        '& > div': {
            margin: '0 auto'
        }
    },
    footerLogo: {
        height: 32
    }
});

const Main = () => {
    const { classes } = useStyles();

    const { statsStore } = useStores();
    useEffect(() => {
        statsStore.loadStats();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={classes.mailLayout}>
            <Header
                menu={MENU}
                classNames={{
                    root: classes.headerRoot,
                    signInButton: classes.signInButton
                }}
            />
            <Search />
            <Feed />
            <Assessment />
            <SDK />
            <Blog />
            <Tools />
            <Plugins />
            <Customers />
            <ParterCTA />
            <FooterBar
                customClasses={{
                    footerRoot: classes.footerRoot,
                    footerLogo: classes.footerLogo
                }}
            />
            <ScrollUpButton />
        </div>
    );
};

export default Main;
